import {useMemo} from 'react';

import {FormItem, FormItemValueType} from '@dev-landing/strapi/types';
import {HelpComplaintItemType} from '@web-landing/strapi/types';

import {useLocale} from '@utils/hooks/useLocale';

const getValidateText = (locale: string, length?: number) => {
  return {
    minLength:
      locale === 'ru'
        ? `Не менее ${length} символов`
        : `No less than ${length} characters`,
    maxLength:
      locale === 'ru'
        ? `Не более ${length} символов`
        : `No more than ${length} characters`,
    pattern: locale === 'ru' ? 'Неправильный формат' : 'Unexpected format',
    required: locale === 'ru' ? 'Обязательное поле' : 'Required field',
  };
};

const regexMap: Partial<Record<FormItemValueType, RegExp>> = {
  url: /^((htt)ps?:\/\/)[a-zA-Zа-яА-ЯЁё0-9_/\-\\.]+\.([A-Za-zА-Яа-яЁё/]{2,5})[a-zA-Zа-яА-ЯЁё0-9_/\\&?=\-.~%]*/,
  email: /^\S+@\S+\.\S+$/,
  phone_number: /^[+]{0,1}[0-9]{0,3}\s*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/,
  social_network_id: /^@?[A-Za-z0-9_.]+$/,
};

export default function useValidationRules({
  optional,
  minLength,
  maxLength,
  valueType,
}: FormItem | HelpComplaintItemType) {
  const locale = useLocale();

  return useMemo(
    () => ({
      required: {
        value: !optional,
        message: getValidateText(locale).required,
      },
      ...(typeof minLength === 'number' &&
        minLength > 0 && {
          minLength: {
            value: minLength,
            message: getValidateText(locale, minLength).minLength,
          },
        }),
      ...(typeof maxLength === 'number' &&
        maxLength > 0 && {
          maxLength: {
            value: maxLength,
            message: getValidateText(locale, maxLength).maxLength,
          },
        }),
      ...(!!valueType &&
        regexMap[valueType] && {
          pattern: {
            value: regexMap[valueType]!,
            message: getValidateText(locale).pattern,
          },
        }),
    }),
    [optional, minLength, maxLength, valueType, locale],
  );
}
